"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const hooks_1 = require("common/hooks");
const react_hooks_async_modal_1 = require("react-hooks-async-modal");
const pages_1 = require("./pages");
require("bootstrap/dist/css/bootstrap.min.css");
require("./assets/css/main.scss");
require("./assets/css/reset.scss");
require("./assets/css/field.scss");
require("./assets/css/level.scss");
require("./assets/css/hero.scss");
require("./assets/css/navbar.scss");
require("./assets/css/tooltip.scss");
require("react-tooltip/dist/react-tooltip.css");
const reportWebVitals_1 = require("./reportWebVitals");
const react_router_dom_1 = require("react-router-dom");
const react_tooltip_1 = require("react-tooltip");
const shortcutHandler_1 = require("utils/shortcutHandler");
const google_spreadsheet_1 = require("utils/google-spreadsheet");
const client_1 = require("react-dom/client");
const version_1 = require("app/version");
const autoUpdate_1 = require("common/autoUpdate");
const standard_1 = require("react-hook-schema/standard");
(0, autoUpdate_1.configureAudoUpdate)(version_1.appVersion);
const Providers = ({ children, }) => {
    return (react_1.default.createElement(hooks_1.LocaleProvider, null,
        react_1.default.createElement(standard_1.ToastProvider, null,
            react_1.default.createElement(google_spreadsheet_1.SpreadsheetContextProvider, null, children))));
};
const router = (0, react_router_dom_1.createBrowserRouter)(pages_1.Routes);
const app = (react_1.default.createElement(Providers, null,
    react_1.default.createElement(react_tooltip_1.Tooltip, { id: "tooltip", style: { zIndex: 1000 }, opacity: 1 }),
    react_1.default.createElement(react_tooltip_1.Tooltip, { id: "tooltip-click", openEvents: { click: true }, closeEvents: { click: true }, style: { zIndex: 1010 } }),
    react_1.default.createElement(react_tooltip_1.Tooltip, { id: "tooltip-multiline", style: { zIndex: 1010, width: "300px" } }),
    react_1.default.createElement(shortcutHandler_1.ShortcutProvider, null,
        react_1.default.createElement(react_hooks_async_modal_1.ModalProvider, null,
            react_1.default.createElement(shortcutHandler_1.Toasts, null),
            react_1.default.createElement(react_router_dom_1.RouterProvider, { router: router })))));
(0, reportWebVitals_1.reportWebVitals)();
const container = document.getElementById("root");
if (container) {
    const root = (0, client_1.createRoot)(container);
    root.render(app);
}
